<app-nav-bar></app-nav-bar>
<div class="container" style="padding-top: 70px;padding-bottom: 40px;">
  <router-outlet />
</div>
<app-footer-bar></app-footer-bar>

